import { render, staticRenderFns } from "./Entrepreneurship.vue?vue&type=template&id=34625e24&"
import script from "./Entrepreneurship.vue?vue&type=script&lang=js&"
export * from "./Entrepreneurship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports